import styled from 'styled-components';

/**
 * List of coding tips to display in the code tip panel. Go ahead, add a couple
 * more!
 */
export const CODING_TIPS: string[] = [
  'Take time off the screen to think about the problem you are trying to solve.',
  'Break down complex problems into smaller, manageable steps.',
  'Write down a plan for your solution before you start writing code.',
  'Test your code frequently!',
  'Use descriptive variable names to make your code more readable.',
  'Add comments to explain complex logic and help others understand your code.',
  'Take regular breaks to avoid burnout and maintain focus.',
  'Ask for help when stuck - programming is collaborative!',
  'Error messages are your friends - they help guide you to solutions!',
  'Keep learning - programming is a journey of continuous improvement!',
];

export const CODING_TIPS_SPANISH: string[] = [
  'Tómate tiempo lejos de la pantalla para pensar sobre el problema que tratas de resolver.',
  'Divide problemas complejos en pasos más pequeños y manejables.',
  'Escribe un plan para tu solución antes de empezar a escribir código.',
  '¡Prueba tu código frecuentemente!',
  'Usa nombres de variables descriptivos para hacer tu código más legible.',
  'Añade comentarios para explicar lógica compleja y ayudar a otros a entender tu código.',
  'Toma descansos regulares para evitar el agotamiento y mantener la concentración.',
  '¡Pide ayuda cuando te bloquees - la programación es colaborativa!',
  '¡Los mensajes de error son tus amigos - te ayudan a encontrar soluciones!',
  '¡Sigue aprendiendo - la programación es un proceso de mejora continua!',
];

/**
 * Styled component for the code tip panel.
 */
export const CodeTipPanel = styled.div`
  border: 2px solid black;
  padding: 10px;
  border-radius: 10px;
  margin: 2rem auto;
  width: 90%;
  max-width: 400px; /* optional, for a nice narrower tip area */
`;
